import React from 'react';
import Img1 from './img/logo-poli-blanco.svg';
import Img2 from './img/logo-poli-color.svg';

import './css/styles.css';
import '../icon_fonts/fonts/style.css';

class Footer extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            urlInstagram: '',
            urlTwitter: '',
            director_nombre: '',
            director_correo: '',
            director_telefonos: '',
        }
    }

    componentWillMount(){

        fetch('/api/uip/instagram/url', {
            method: 'GET',
            heders: {
                'Content-Type': 'application/json' 
            }
        })
            .then(response => response.json())
            .then(response => { this.setState({ urlInstagram:  response[0].url})})
            .catch(response => console.log(response))
        
        fetch('/api/uip/twitter/url', {
            method: 'GET',
            heders: {
                'Content-Type': 'application/json' 
            }
        })
            .then(response => response.json())
            .then(response => this.setState({ urlTwitter:  response[0].url}))
            .catch(response => console.log(response))

        fetch('/api/uip/youtube/url', {
            method: 'GET',
            heders: {
                'Content-Type': 'application/json' 
            }
        })
            .then(response => response.json())
            .then(response => this.setState({ urlYoutube:  response[0].url}))
            .catch(response => console.log(response))

        fetch('/api/uip/director/datos', {
                method: 'GET',
                heders: {
                    'Content-Type': 'application/json' 
                }
            })
                .then(response => response.json())
                .then(response => {
                    this.setState({ 
                        director_nombre: response[0].nombre,
                        director_correo: response[0].correo,
                        director_telefonos: response[0].telefonos,
                    })
                })
                .catch(response => console.log(response))
    }

    render() {
        return (
            <footer>
                <div className="row footer">
                    <div className="col s12 m4 l3">
                        <img src={Img1} className="small_img_left"></img>
                    </div>
                    <div className="col s12 m4 l3 push-l3">
                        <div className="container_director">
                            <div className="container_social_network">
                                <div className="container_icons_footer">
                                    <div className="isHidden">
                                        <i className="icon-instagram icons-footer"></i>
                                        <span className="icon-twitter icons-footer"></span>
                                        <span className="icon-youtube icons-footer"></span>
                                    </div>
                                    <div className="isVisible">
                                        <a href={this.state.urlInstagram} target="_blank">
                                            <i className="icon-instagram icons-footer hvr-pop"></i>
                                        </a>
                                        <a href={this.state.urlTwitter} target="_blank">
                                            <i className="icon-twitter icons-footer hvr-pop"></i>
                                        </a>
                                        <a href={this.state.urlYoutube} target="_blank">
                                            <i className="icon-youtube icons-footer hvr-pop"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="text-justify"><span>Dirección de la Unidad:</span></div>
                            <div className="text-justify text-bold"><span>{this.state.director_nombre}</span></div>
                            <div className="text-justify"><span>{this.state.director_correo}</span></div>
                            <div className="text-justify"><span>{this.state.director_telefonos}</span></div>
                        </div>
                    </div>
                    <div className="col s12 m4 l3 push-l3">
                        <img src={Img2} className="pl-30 small_img_right"></img>
                    </div>
                </div>
                <div className="container_autor"><span className="autor">@utor: Alex Daniel Meza</span></div>
            </footer>
        );
    }
}

export default Footer;